interface BankAccountGroupProps {
    bank_logo_url: string;
    bank_account_owner_name: string;
    bank_account_iban: string;
}

export default function BankAccountGroup({bank_logo_url, bank_account_owner_name, bank_account_iban}: BankAccountGroupProps) {

    return (
        <div className="flex items-center py-2 px-3  rounded-lg w-fit">
            <img src={bank_logo_url} alt={""} className="size-7 shrink-0 rounded-full bg-gray-200" />
            <div className="ml-3">
                <span className="block truncate">{bank_account_owner_name}</span>
                <span className="block text-xs text-gray-500 truncate">{bank_account_iban}</span>
            </div>
        </div>
    )
}